import { createContext } from "react";
export const langContext = createContext({
    language: 'en',
    langSetFunc : () => {}
})